import axios from 'axios'
import {Notification, MessageBox, Message} from 'element-ui'
// import store from '@/store'
import {getToken,removeToken} from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import {showFullScreenLoading, tryHideFullScreenLoading} from "@/utils/loading"

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.API_ROOT,
  // 超时
  timeout: 20000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if ((getToken()||sessionStorage.getItem('token')) && !isToken) {
    config.headers['Authorization'] = getToken() ||sessionStorage.getItem('token')// 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              let subPart = encodeURIComponent(params) + '=';
              url += subPart + encodeURIComponent(value[key]) + '&';
            }
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if(config.url.indexOf('weChatPay')<0){
    showFullScreenLoading()
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || res.code||200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
	var curWwwPath=window.document.location.href;
	// console.log(curWwwPath.indexOf('acpUser'),"当前路径")
	if(curWwwPath.indexOf('acpUser') != -1 || curWwwPath.indexOf('empUser') != -1){
		if (code === 401 || code === 700) {
		  MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
		      confirmButtonText: '返回首页',
		      cancelButtonText: '取消',
		      type: 'warning'
		    }
		  ).then(() => {
		    // store.dispatch('LogOut').then(() => {
		    location.href = '/';
		    // })
		  }).catch(() => {
        location.href = '/';
		  });
		  return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
		}else
		  tryHideFullScreenLoading()
	}else
		tryHideFullScreenLoading()
    if(code === 10000){ // 特殊， 当后端返回token不对时 状态码 是 10000
      // 清除所有缓存 返回首页
      removeToken();
      localStorage.removeItem("userId");
      sessionStorage.removeItem("Headportrait");
      sessionStorage.removeItem("usertype");
      sessionStorage.removeItem("Mobilephone");
      location.href = "/?tips=" + 10000;
      return;
    }else if (code === 401 || code === 700) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '返回首页',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        // store.dispatch('LogOut').then(() => {
        location.href = '/';
        // })
      }).catch(() => {
        location.href = '/';
      });
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    } else if (code !== 200 && code !== 501) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    // showFullScreenLoading();
    tryHideFullScreenLoading() // 清除loding
    let {message} = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 20 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js